import axios from 'axios'
import React, { useState, useEffect } from 'react'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { Button, Card, Container, Form, Modal, Table } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const Commission = () => {
  const [modalVisible, setModalVisible] = useState(false)
  const [transactionModalVisible, setTransactionModalVisible] = useState(false)
  const [
    transactionModalSuccessfullVisible,
    setTransactionModalSuccessfullVisible,
  ] = useState(false)
  const [loading, setLoading] = useState(true)
  const [brokers, setBrokers] = useState([])
  const [selectedBrokerId, setSelectedBrokerId] = useState('')
  const [message, setMessage] = useState('')
  const navigate = useNavigate()
  const [selectedBrokerData, setSelectedBrokerData] = useState({
    total_bookings: '',
    total_transaction_amount: '',
    brokege_amount: '',
    total_paid_amount: '',
    pending_amount: '',
    child_commissions: '',
  })
  console.log('message', message)
  const [showReferCommission, setShowReferCommission] = React.useState(false)
  const [formData, setFormData] = useState({
    paid_amount: '',
    date: '',
    method_type: '',
    managed_by: '',
  })
  console.log('paid ammount is ', formData.paid_amount)
  const convertNumberToWords = (num) => {
    const ones = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
    ]
    const teens = [
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ]
    const tens = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ]

    if (num === 0) return ''

    let words = ''

    // Function to convert hundreds
    const convertHundreds = (n) => {
      if (n < 10) return ones[n]
      if (n < 20) return teens[n - 10]
      if (n < 100) {
        return tens[Math.floor(n / 10)] + (n % 10 > 0 ? ' ' + ones[n % 10] : '')
      }
      return (
        ones[Math.floor(n / 100)] +
        ' Hundred' +
        (n % 100 > 0 ? ' ' + convertHundreds(n % 100) : '')
      )
    }

    // Handle Lakh and Crore
    const crore = Math.floor(num / 10000000)
    const lakh = Math.floor((num % 10000000) / 100000)
    const thousand = Math.floor((num % 100000) / 1000)
    const remainder = num % 1000

    if (crore > 0) {
      words += convertHundreds(crore) + ' Crore '
    }
    if (lakh > 0) {
      words += convertHundreds(lakh) + ' Lakh '
    }
    if (thousand > 0) {
      words += convertHundreds(thousand) + ' Thousand '
    }
    if (remainder > 0) {
      words += convertHundreds(remainder)
    }

    return words.trim() + ' Only'
  }
  const num = 340569
  const result = `${num} : ${convertNumberToWords(num)}`
  console.log(result)

  useEffect(() => {
    const amountInWords = convertNumberToWords(Number(formData.paid_amount))
    setFormData((prevBooking) => ({
      ...prevBooking,
      paid_amount_in_words: amountInWords,
    }))
  }, [formData.paid_amount])

  const inputFormHandler = (e) => {
    const { name, value } = e.target
    console.log(`Updating formData: ${name} = ${value}`)
    setFormData((prevData) => ({ ...prevData, [name]: value }))
  }

  const handleSelectBrokerId = (brokerId) => {
    console.log('Broker id is selected: ', brokerId)
    setSelectedBrokerId(brokerId) // Set selected broker ID
    const brokerData = brokers.find(
      (broker) => broker.broker_id === parseInt(brokerId, 10),
    )
    console.log('Broker data found: ', brokerData)
    setSelectedBrokerData(brokerData || null)
    console.log('Selected Broker Data:', brokerData)
  }

  useEffect(() => {
    const fetchBrokers = async () => {
      const token = Cookies.get('authToken')
      try {
        const brokersRes = await axios.get(
          BASE_URL+'/brokers/search',
          { headers: { Authorization: `Bearer ${token}` } },
        )
        if (brokersRes.data?.data?.length) {
          setBrokers(brokersRes.data.data)
        } else {
          throw new Error('No associates found.')
        }
      } catch (error) {
        console.error('Error fetching associates:', error)
        toast.error(
          error.response?.data?.message ||
            'Failed to fetch associates. Please try again later.',
        )
      } finally {
        setLoading(false)
      }
    }

    fetchBrokers()
  }, [])

  const handleAssociateNext = async (e) => {
    e.preventDefault()
    if (
      !selectedBrokerId ||
      !selectedBrokerData ||
      !selectedBrokerData.broker_id
    ) {
      toast.error('Please select a valid associate name.')
      return
    }
    // Debugging: Log the selected broker ID and data before checking
    console.log('Selected Broker ID:', selectedBrokerData.broker_id)
    console.log('Selected Broker Data:', selectedBrokerData)

    console.log('Selected Broker ID  after Caclculate:', selectedBrokerId)
    const token = Cookies.get('authToken')
    try {
      const response = await axios.get(
        BASE_URL+`/associate/${selectedBrokerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )

      if (response.status === 200 && response.data.data) {
        const updatedData = {
          ...response.data.data,
          broker_id: selectedBrokerData.broker_id,
        }

        // Update the state with merged data
        setSelectedBrokerId((prevData) => ({
          ...prevData,
          ...updatedData,
        }))

        setModalVisible(true)
      } else {
        setModalVisible(true)
        toast.error('Failed to fetch selected associate data.')
      }
    } catch (error) {
      setModalVisible(true)
      toast.error(
        error.response?.data?.message ||
          'Failed to fetch associate data. Please try again later.',
      )
    }
  }

  const handleAssociatePayment = async (e) => {
    e.preventDefault()
    // setShowPreview(false)
    // setTransactionModalSuccessfullVisible(true)
    console.log(
      'Broker id after proceed with payment: ',
      selectedBrokerData?.broker_id,
    )

    const obj = { broker_id: selectedBrokerData?.broker_id } // Use broker_id directly
    const myJSON = JSON.stringify(obj)
    console.log('Associate id with data after do payment ', myJSON)

    const validPaymentMethods = ['ONLINE', 'CASH', 'CHEQUE']

    if (
      !formData.paid_amount ||
      isNaN(formData.paid_amount) ||
      formData.paid_amount <= 0
    ) {
      toast.error('Please enter a valid amount.')
      setLoading(false)
      return
    }

    if (
      !formData.method_type ||
      !validPaymentMethods.includes(formData.method_type)
    ) {
      toast.error('Please select a valid payment method.')
      setLoading(false)
      return
    }
    if (
      (formData.method_type === 'CHEQUE' ||
        formData.method_type === 'ONLINE') &&
      !formData.online_transaction_number
    ) {
      toast.error(
        `Please enter ${
          formData.method_type === 'CHEQUE'
            ? 'Cheque Number'
            : 'Transaction Number'
        }`,
      )
      return
    }
    if (!formData.date) {
      toast.error('Payment date is required.')
      setLoading(false)
      return
    }

    const token = Cookies.get('authToken')

    try {
      const payload = { ...formData, broker_id: selectedBrokerData?.broker_id }

      const response = await axios.post(
        BASE_URL+`/broker/payment/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )

      if (response.data.data === 200) {
        toast.success('Payment successful!')
        console.log('Payment Response:', response.data.data)

        setMessage(response?.data?.result)

        setShowPreview(false)
        setTransactionModalSuccessfullVisible(true)
      } else {
        setMessage(response?.data?.result)
        setShowPreview(false)
        setTransactionModalSuccessfullVisible(true)
      }
    } catch (error) {
      console.error('Payment error:', error)
      toast.error(
        error.response?.data?.result ||
          'Failed to save transaction. Please try again later.',
      )
      setLoading(false)
    }
  }

  const handleReferCommission = () => {
    setShowReferCommission(!showReferCommission)
  }

  const handleopentransaction = () => {
    if (!selectedBrokerData?.broker_id) {
      toast.error('Please select an associate first')
      return
    }
    console.log(
      'Selected Broker ID after do payment:',
      selectedBrokerData?.broker_id,
    )
    setTransactionModalVisible(true)
    setModalVisible(false)
  }

  const handleTransactionClose = () => {
    setTransactionModalVisible(false)
    setTimeout(() => {
      window.location.href = '/commission'
      window.location.reload() // Force a page reload
    }, 300)
  }

  const handleClose = () => {
    window.location.href = '/commission'
    window.location.reload()
  }

  const handleTransactionSuccessfullPrint = () => {
    if (selectedBrokerData?.broker_id) {
      console.log(
        'Selected Broker id after print button:',
        selectedBrokerData?.broker_id,
      )

      navigate(`/transactionprint/${selectedBrokerData?.broker_id}`, {
        state: { formData },
      })
    } else {
      console.log('No valid broker selected.') // Debugging when no broker ID is found
      toast.error('No valid associate selected for printing.')
    }
  }

  const backHandler = () => {
    setModalVisible(true)
    setTransactionModalVisible(false)
  }

  const [showPreview, setShowPreview] = useState()
  const togglePreview = (e) => {
    e.preventDefault()
    setShowPreview(true)

    setTransactionModalVisible()
  }
  const handleEditPreview = () => {
    setShowPreview(false)
    setFormData((prevData) => ({
      ...prevData, // Keep the existing form data
      transaction_amount: formData.paid_amount,
      transaction_amount_in_words: formData.paid_amount_in_words,
      online_transaction_number: formData.online_transaction_number,
      transaction_date: formData.date,
      method_type: formData.method_type,
    }))
    setTransactionModalVisible(true)
  }
  return (
    <>
      {' '}
      <style>
        {`
    /* styles.css */
      @keyframes blinkColors {
        0% {
          color: green;
        }
        50% {
          color: red;
        }
        100% {
          color: green;
        }
      }

      .blink {
        font-size: 2rem;
        animation: blinkColors 1s infinite;
      }
      `}
      </style>
  <Container className="pb-3" style={{fontFamily: theme.font.family, }}>
<div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>


        <p
          className="mb-4 fw-bold"
          style={{
            color: theme.colors.primary,
            borderBottom: `2px solid ${theme.colors.secondary}`,
            paddingBottom: '8px',
            
            fontSize: '1.5rem',
          }}
        >
            Associate Commission
        </p>

        {loading ? (
          <p className="text-center">Loading associates...</p>
        ) : brokers.length > 0 ? (
          <div className="text-center" style={{ marginTop: '4rem' }}>
            <label
              htmlFor="broker-select"
              className="fw-bold me-2"
              style={{ fontSize: '1.2rem', letterSpacing: '.1em' }}
            >
              Select Associate:
            </label>
            <select
              id="broker-select"
              value={selectedBrokerId}
              onChange={(e) => handleSelectBrokerId(e.target.value)}
              className="form-select d-inline-block w-50 w-md-25"
              style={{
                fontSize: '1rem',
                padding: '8px 12px',
                borderRadius: '5px',
                border: '1px solid #ddd',
              }}
            >
              <option value="" disabled>
                SELECT
              </option>
              {brokers
                .filter((broker) => broker.broker_id !== 62)
                .map((broker) => (
                  <option key={broker.broker_id} value={broker.broker_id}>
                    {broker.name.toUpperCase()} (ID : {broker.broker_id})
                  </option>
                ))}
            </select>
          </div>
        ) : (
          <p className="text-center text-muted">No associates found.</p>
        )}

        <div className="text-center " style={{ marginTop: '2rem' }}>
          {selectedBrokerId ? (
            <p style={{ letterSpacing: '0.1em' }}>
              You selected associate:{' '}
              <span className="fw-bold" style={{color: theme.colors.secondary}}>
                {selectedBrokerData.name.toUpperCase()}
              </span>
            </p>
          ) : (
            <p className="text-muted">No associate selected.</p>
          )}
        </div>


                  <div className="d-grid mt-4">
                    <Button
                      type="submit"
                      className="fw-semibold py-2"
                      style={{
                        backgroundColor: '#4D5C2B',
                        border: 'none',
                        fontSize: '1.05rem',
                      }}
                      disabled={loading}
            onClick={handleAssociateNext}

                    >
                                 {loading ? 'Loading...' : 'Calculate'}
                    </Button>
                  </div>

        {/* Commission Modal */}
        <Modal
          show={modalVisible}
          onHide={() => setModalVisible(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <div className="w-100 text-center">
              <Modal.Title className="fw-bold" style={{color:theme.colors.secondary}}>
                Payment Details
              </Modal.Title>
            </div>
          </Modal.Header>

          <Modal.Body>
            {selectedBrokerId ? (
                <div
                  className="p-4"
                  style={{
                    fontFamily: "'Lora', serif",
                  }}
                >
                  <h4
                    className="fw-bold text-center mb-4"
                    style={{ color: theme.colors.secondary, letterSpacing: '.1em' }}
                  >
                    Associate Own Commission
                  </h4>
                
                  <table
                    className="table table-bordered"
                    style={{
                      width: '80%',
                      margin: '0 auto',
                      borderCollapse: 'collapse',
                      fontSize: '1.3rem',
                    }}
                  >
                    <tbody>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Total Bookings</th>
                        <td>{selectedBrokerId?.total_bookings}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Total Booking Amount</th>
                        <td>{selectedBrokerId.total_transaction_amount}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Total Associate Brokerage</th>
                        <td>{Math.floor(Number(selectedBrokerId.associate_brokege_amount))}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Referred Total Commission</th>
                        <td>{Math.floor(Number(selectedBrokerId.child_total_commissions))}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Grand Total Commission</th>
                        <td>{Math.floor(Number(selectedBrokerId.grand_total_commission))}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>TDS Charges</th>
                        <td>{Math.floor(Number(selectedBrokerId.tds_charge))}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Admin Charges</th>
                        <td>{Math.floor(Number(selectedBrokerId.admin_charge))}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Net Grand Total Commission</th>
                        <td>{Math.floor(Number(selectedBrokerId.net_grand_total_commission))}</td>
                      </tr>
                      <tr>
                        <th style={{ color: theme.colors.primary }}>Total Paid Amount</th>
                        <td >{selectedBrokerId.total_paid_amount}</td>
                      </tr>
                      <tr>
                        <th
                          style={{
                            color: 'green',
                            fontWeight: 'bold',
                            fontSize: '1.5rem',
                          }}
                        >
                          Payable Pending Amount
                        </th>
                        <td
                          style={{
                            color: 'green',
                            fontWeight: 'bold',
                            fontSize: '1.5rem',
                          }}
                        >
                          {Math.floor(Number(selectedBrokerId.net_pending_amount))} /-
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

            ) : (
              <p>No details available for this associate.</p>
            )}

            {showReferCommission && (
              <Container className="mt-0" style={{ maxWidth: '750px' }}>
                <Card className="p-3 shadow-sm rounded-3">
                  <Card.Header className=" text-center bg-light" style={{color: theme.colors.primary}}>
                    <h4 className="mb-2 fw-bold">
                      Referred Associate Commission
                    </h4>
                  </Card.Header>

                  <Card.Body>
                    <Table
                      bordered
                      hover
                      responsive="md"
                      className="text-center table table-striped table-bordered table-hover"
                    >
                      <thead className="position-sticky top-0 text-start table-success">
                        <tr>
                          <th>Referred Associate ID</th>
                          <th>Referred Associate Name</th>
                          <th>Total Booking Amount</th>
                          <th>Total Commission</th>
                          <th>TDS {' (5%)'}</th>
                          <th>Admin Fees{' (5%)'}</th>
                          <th>Payable Commission</th>
                        </tr>
                      </thead>
                      <tbody className="text-start">
                        {selectedBrokerId?.child_commissions &&
                        Object.entries(selectedBrokerId.child_commissions)
                          .length > 0 ? (
                          Object.entries(
                            selectedBrokerId.child_commissions,
                          ).map(([id, child_commission]) => (
                            <tr key={id}>
                              <td>{id}</td>
                              <td>{child_commission.name}</td>
                              <td>{child_commission.total_booking_amount}</td>
                              <td>{child_commission.total_commission}</td>
                              <td>{child_commission.tds}</td>
                              <td>{child_commission.admin_ch}</td>
                              <td>{child_commission.final_commission}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Container>
            )}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center gap-4">
            <div className="text-center">
              <button
                className="fw-bold btn"
                style={{backgroundColor: theme.colors.primary , color: theme.colors.background}}
                onClick={handleReferCommission}
              >
                Refer Associate Commission
              </button>
            </div>
            {/* <div closeButton className="text-center">
              <button
                className="fw-bold btn btn-outline-danger"
                onClick={handleClose}
              >
                Close
              </button>
            </div> */}
            <div className="text-center">
              <button
                className="fw-bold btn btn-outline-primary"
                onClick={handleopentransaction}
              >
                Do Payment
              </button>
            </div>
            <div>
              {selectedBrokerId ? (
                <Link
                  to={`/associatebookingsdetails/${selectedBrokerData.broker_id}`}
                  state={{ from: '/commission' }}
                >
                  See Bookings detail
                </Link>
              ) : (
                <p>No details available for this associate.</p>
              )}
            </div>
          </Modal.Footer>
        </Modal>

        {/* Transaction Modal */}

        <Modal
          show={transactionModalVisible}
          onHide={() => setTransactionModalVisible(false)}
          centered
          size="lg"
        >
          <Modal.Header>
            <div className="w-100 text-center">
              <Modal.Title className="fw-bold text-success bg-light">
                Make Payment
              </Modal.Title>
            </div>
          </Modal.Header>
          <div className="m-2 d-flex">
            <Button
              variant="outline-success"
              className="fw-bold "
              onClick={backHandler}
            >
              <i
                className="fa fa-arrow-left"
                style={{ fontSize: '1rem', marginRight: '8px' }}
              ></i>
              Back to Payment Details
            </Button>
          </div>

          <Modal.Body>
            {selectedBrokerId ? (
              <Form>
                <Form.Group controlId="paid_amount">
                  <Form.Label>Amount *</Form.Label>
                  <Form.Control
                    type="number"
                    name="paid_amount"
                    placeholder="Enter Transaction Amount"
                    value={formData.paid_amount}
                    onChange={inputFormHandler}
                    // onClick={handleTransactionClose}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="paid_amount_in_words">
                  <Form.Label>Transaction amount in words</Form.Label>
                  <Form.Control
                    type="textarea"
                    id="paid_amount_in_words"
                    name="paid_amount_in_words"
                    value={formData.paid_amount_in_words}
                    onChange={inputFormHandler}
                    // onClick={handleTransactionClose}
                    disabled
                  />
                </Form.Group>

                <Form.Group controlId="method_type" className="mt-3">
                  <Form.Label>Payment Method *</Form.Label>
                  <Form.Select
                    name="method_type"
                    value={formData.method_type}
                    onChange={inputFormHandler}
                    // onClick={handleTransactionClose}
                    required
                  >
                    <option value="">SELECT</option>
                    <option value="ONLINE">ONLINE</option>
                    <option value="CASH">CASH</option>
                    <option value="CHEQUE">CHEQUE</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group
                  controlId="online_transaction_number"
                  className="mt-3"
                >
                  <Form.Label>
                    {formData.method_type === 'CASH'
                      ? 'Not Mandatory'
                      : formData.method_type === 'CHEQUE'
                      ? 'Cheque Number *'
                      : 'Transaction Number *'}
                  </Form.Label>

                  <Form.Control
                    type="text"
                    name="online_transaction_number"
                    value={formData.online_transaction_number}
                    onChange={inputFormHandler}
                    // onClick={handleTransactionClose}
                    placeholder={
                      formData.method_type === 'CASH'
                        ? null
                        : formData.method_type === 'CHEQUE'
                        ? 'Enter Cheque Number'
                        : 'Enter Transaction Number'
                    }
                    disabled={formData.method_type === 'CASH'}
                  />
                </Form.Group>

                <Form.Group controlId="date" className="mt-3">
                  <Form.Label>Transaction Date *</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={inputFormHandler}
                    // onClick={handleTransactionClose}
                    required
                  />
                </Form.Group>

                <Modal.Footer className="d-flex justify-content-center gap-4">
                  <div className="text-center">
                    <button
                      className="fw-bold btn btn-outline-danger"
                      onClick={handleTransactionClose}
                    >
                      Close
                    </button>
                  </div>
                  <div className="text-center">
                    <button
                      className="fw-bold btn btn-outline-success"
                      onClick={togglePreview}
                    >
                      Show Preview
                    </button>
                  </div>
                </Modal.Footer>
              </Form>
            ) : (
              <p>Something wents wrong.</p>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={transactionModalSuccessfullVisible}
          onHide={() => {
            setTransactionModalSuccessfullVisible(false)
          }}
          centered
          size="lg"
        >
          <Modal.Header>
            <div className="w-100 text-center">
              <Modal.Title className="fw-bold text-success bg-light">
                Payment Status
              </Modal.Title>
            </div>
          </Modal.Header>

          <Modal.Body className="d-6">
            <div
              className="fw-bold text-primary text-center"
              style={{ letterSpacing: '.2em', fontSize: '1.4rem' }}
            >
              {message}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center gap-4">
            <div className="text-center">
              <button
                className="fw-bold btn btn-outline-danger"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
            <div className="text-center">
              <button
                className="fw-bold btn btn-outline-primary"
                onClick={handleTransactionSuccessfullPrint}
              >
                Print
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Transaction preview modal */}
        <Modal
          show={showPreview}
          onHide={() => setShowPreview(false)}
          centered
          size="xxl"
        >
          <Modal.Header closeButton closeLabel="Close" title="Close">
            <div className="w-100 text-center">
              <Modal.Title className="fw-bold text-primary bg-light">
                Transaction Preview
              </Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="py-5">
            <p>
              <strong>Transaction Amount : </strong>
              {formData.paid_amount}
            </p>
            <p>
              <strong>Transaction Amount in Words : </strong>
              {formData.paid_amount_in_words}{' '}
            </p>
            <p>
              <strong>Payment Method : </strong>
              {formData.method_type}
            </p>
            <p>
              {formData.method_type !== 'CASH' && (
                <strong>
                  {formData.method_type === 'CHEQUE'
                    ? 'Cheque Number'
                    : 'Online Transaction Number'}{' '}
                  :{' '}
                </strong>
              )}
              {formData.method_type !== 'CASH' &&
                formData.online_transaction_number}
            </p>
            <p>
              <strong>Transaction Date : </strong>
              {formData.date}
            </p>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button
              className="fw-bold btn"
              style={{ width: '48%', letterSpacing: '1px' }}
              variant="secondary"
              onClick={handleEditPreview}
            >
              Edit Transaction
            </Button>

            <Button
              className="fw-bold btn"
              style={{ width: '48%', letterSpacing: '1px' }}
              variant="primary"
              onClick={handleAssociatePayment}
              // type="submit"
            >
              Proceed with payment
            </Button>
          </Modal.Footer>
        </Modal>
        </div>
      </Container>
    </>
  )
}

export default Commission
